import * as d3 from 'd3';
import { css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('apt-progress-bar-chart')
export class AptProgressBarChart extends LitElement {
  @property({ type: Number })
  data = 0;

  @property({ type: Number })
  width = 100;

  @property({ type: Number })
  height = 12;

  @property({ type: String })
  bordercolor = 'gray';

  @property({ type: String })
  backgroundcolor = 'lightgray';

  @property({ type: String })
  primarycolor = 'green';

  @property({ type: String })
  secondarycolor = 'red';

  static override styles = css`
    :host {
      display: inline-block;
    }
  `;

  override render() {
    // Have I mentioned how much I hate TypeScript sometimes?
    d3.select(this.shadowRoot as unknown as Element)
      .selectChild('svg')
      .remove();

    const colors = d3
      .scaleThreshold()
      .domain([99.99, 100])
      // @ts-ignore
      .range([this.secondarycolor, this.primarycolor]);

  if(this.data) {
    const svg = d3
      .select(this.shadowRoot as unknown as Element)
      .append('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .style('background-color', this.backgroundcolor)
      .style('border', `1px solid  ${this.bordercolor}`)
      .style('border-radius', '5px');

    svg
      .selectAll('rect')
      .data([this.data])
      .enter()
      .append('rect')
      .attr('fill', (d) => colors(d))
      .attr('height', this.height)
      .attr('width', (d) => (this.width * (d as number) ) / 100);
    }
  }
}
